module.exports = require("@workbench-stack/components");